export const MAIN_LAYOUT_HEADER_HEIGHT = '3.625rem';

export const MAIN_LAYOUT_FOOTER_HEIGHT = '3.625rem';
